import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authService } from "../../services/authService";
import { acceptInvitation } from "../../store/slices/authSlice";
import Icon from "../../components/Common/Icon";

export default function AcceptInvitationPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [info, setInfo] = useState(null); // { email, salonName, valid }
  const [checking, setChecking] = useState(true);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    authService
      .getInvitation(token)
      .then((res) => setInfo(res.data.data))
      .catch(() => setInfo({ valid: false }))
      .finally(() => setChecking(false));
  }, [token]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError("Şifreler eşleşmiyor");
      return;
    }
    setLoading(true);
    const result = await dispatch(acceptInvitation({ token, password }));
    setLoading(false);
    if (acceptInvitation.fulfilled.match(result)) {
      navigate("/dashboard");
    } else {
      setError(result.payload);
    }
  };

  const invalid = !token || (info && !info.valid);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 to-secondary/10 p-4">
      <div className="w-full max-w-md bg-surface-card rounded-3xl shadow-modal p-8">
        {checking ? (
          <p className="text-center text-on-surface-variant">Davet kontrol ediliyor…</p>
        ) : invalid ? (
          <div className="text-center">
            <div className="w-14 h-14 rounded-2xl bg-error/10 text-error flex items-center justify-center mx-auto mb-4">
              <Icon name="link_off" className="!text-[28px]" />
            </div>
            <h1 className="text-xl font-bold text-on-surface">Geçersiz veya Süresi Dolmuş Davet</h1>
            <p className="text-on-surface-variant text-sm mt-1">
              Bağlantı geçersiz ya da 1 saatlik süresi dolmuş. Yöneticinizden yeni bir davet isteyin.
            </p>
            <button
              onClick={() => navigate("/login")}
              className="mt-6 text-primary font-semibold hover:underline"
            >
              Giriş sayfasına dön
            </button>
          </div>
        ) : (
          <>
            <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-4">
              <Icon name="verified_user" className="!text-[28px]" />
            </div>
            <h1 className="text-2xl font-bold text-on-surface">Hesabınızı Aktive Edin</h1>
            <p className="text-on-surface-variant text-sm mt-1">
              <strong>{info.salonName}</strong> için <strong>{info.email}</strong> hesabına
              bir şifre belirleyin.
            </p>

            {error && (
              <div className="mt-4 flex items-center gap-2 text-sm text-error bg-error/10 rounded-xl px-4 py-3">
                <Icon name="error" className="!text-[18px]" /> {error}
              </div>
            )}

            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <PwdField label="Şifre" value={password} onChange={setPassword} />
              <PwdField label="Şifre (tekrar)" value={confirm} onChange={setConfirm} />
              <p className="text-xs text-on-surface-variant">
                En az 8 karakter, 1 büyük harf ve 1 rakam içermeli.
              </p>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary text-white rounded-xl py-3 font-semibold hover:opacity-90 transition active:scale-[0.99] disabled:opacity-50"
              >
                {loading ? "Aktive ediliyor…" : "Hesabı Aktive Et"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

function PwdField({ label, value, onChange }) {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label className="block text-sm font-medium mb-1.5 text-on-surface-variant">{label}</label>
      <div className="relative">
        <input
          type={show ? "text" : "password"}
          required
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full border border-outline-variant rounded-xl pl-3.5 pr-11 py-2.5 focus:ring-4 focus:ring-primary/15 focus:border-primary outline-none transition bg-white"
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          className="absolute right-3.5 top-3 text-on-surface-variant hover:text-primary transition"
        >
          <Icon name={show ? "visibility_off" : "visibility"} className="!text-[20px]" />
        </button>
      </div>
    </div>
  );
}
